import { render } from "./CInfo.vue?vue&type=template&id=5915f496&scoped=true&ts=true&lang=html"
import script from "./CInfo.vue?vue&type=script&lang=ts"
export * from "./CInfo.vue?vue&type=script&lang=ts"

import "./CInfo.vue?vue&type=style&index=0&id=5915f496&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5915f496"]])

export default __exports__